import {Component, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges} from '@angular/core';
import {IoniconsOutline, NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';
import {NgbDropdown} from '@ng-bootstrap/ng-bootstrap';
// noinspection ES6PreferShortImport
import {ResolutionChecker} from "../../../utils";

@Component({
  selector: 'pt-sidebar-item-menu',
  template: `
    <div
      class="hiddenRouterLink"
      [routerLink]="'/' + item.routerLink"
      routerLinkActive="sidebar-link--active"
      #rla="routerLinkActive"
    ></div>

    <ng-container
      *ngIf="collapsed; then menuCollapsed; else menuOpen"
    ></ng-container>
    <ng-template #menuCollapsed>
      <div class="collapsed-menu">
        <div
          id="menu_{{ item.id }}"
          class="sidebar-menu sidebar-menu--collapsed {{ classCss }}"
        >
          <div
            *ngIf="rla.isActive"
            class="sidebar-menu--collapsed--active"
          ></div>
          <pt-icon
            *ngIf="item?.icon"
            [key]="item.icon?.key"
            [iconType]="item.icon?.type"
            [size]="16"
          ></pt-icon>
          <label
            [class.d-none]="collapsed"
            [class.slide-out-bck-center]="collapsed"
          >
            {{ item?.label | async }}
          </label>
        </div>

        <div class="collapsed-menu-items">
          <div class="sidebar-menu--active sidebar-menu-label">
            <span>{{ item.label | async }}</span>
          </div>
          <ng-container *ngFor="let childrenItem of item?.children">
            <pt-sidebar-item-link
              class="p-0 text-start"
              [item]="childrenItem"
              [collapsed]="collapsed"
              [selectionMode]="'subMenu'"
              *ngxPermissionsOnly="childrenItem.permissVisible"
            ></pt-sidebar-item-link>
          </ng-container>
        </div>
      </div>
    </ng-template>

    <ng-template #menuOpen>
      <div
        class="sidebar-menu {{ classCss }}"
        [attr.data-bs-target]="'#' + item?.id"
        [attr.aria-controls]="item?.id"
        data-bs-toggle="collapse"
        aria-expanded="true"
        (click)="openMenu(item)"
        [ngClass]="{
          collapsed: !itemMenuOpen,
          'sidebar-menu--enabled': isEnabled,
          'sidebar-menu--disabled': !isEnabled
        }"
      >
        <div
          *ngIf="rla.isActive && !itemMenuOpen"
          class="sidebar-menu--close--active"
        ></div>
        <pt-icon
          *ngIf="item?.icon"
          [key]="item.icon?.key"
          [iconType]="item.icon?.type"
          [size]="16"
        ></pt-icon>
        <label *ngIf="!collapsed">{{ item?.label | async }}</label>
        <pt-icon
          [key]="itemMenuOpen ? IconArrowUp : IconArrowDown"
          [size]="16"
          class="ms-auto"
        ></pt-icon>
      </div>

      <div
        id="{{ item?.id }}"
        [ngClass]="{ show: itemMenuOpen }"
        class="sidebar-item--menu-content accordion-collapse collapse"
        aria-labelledby="headingOne"
        data-bs-parent="#accordionExample"
      >
        <ng-container *ngFor="let childrenItem of item?.children">
          <pt-sidebar-item-link
            [item]="childrenItem"
            [selectionMode]="'subMenu'"
            [collapsed]="collapsed"
            *ngxPermissionsOnly="childrenItem.permissVisible"
          ></pt-sidebar-item-link>
        </ng-container>
      </div>
    </ng-template>
  `,
  styleUrls: ['sidebar-item-menu.component.scss'],
})
export class SidebarItemMenuComponent implements OnInit, OnChanges {
  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Input() itemMenuOpenedId: string;
  @Input() autoCloseMenuItem: boolean;
  @Output() clickItem = new EventEmitter<NavItem>();

  public classCss: string;

  IconArrowDown = IoniconsOutline.arrowDown;
  IconArrowUp = IoniconsOutline.arrowUp;

  itemMenuOpen = false;
  T = NavItemsType;
  isEnabled = true;
  marginLeftItem = '50px';
  marginTopItem = '-36px';
  heightItem = 'auto';
  private overMenuToogle = false;
  private overMenu = false;

  constructor(
    private permissionService: NgxPermissionsService,
    public renderer2: Renderer2
  ) {}

  ngOnInit(): void {
    this.permissionService
      .hasPermission(this.item.permissEnabled)
      .then((enabled) => {
        this.isEnabled = enabled;
      });
    this.classCss = this.item?.classCss ? this.item?.classCss?.join(' ') : '';
  }

  setOverMenuToogle(isOver: boolean, myDrop: NgbDropdown, id) {
    const btn = document.getElementById(id);
    const scaleValue = ResolutionChecker.getScaleValue(
      document.documentElement.clientWidth
    );
    this.marginLeftItem = btn.offsetWidth * scaleValue + 'px';
    this.marginTopItem = '-' + btn.offsetHeight * scaleValue + 'px';

    this.overMenuToogle = isOver;
    if (this.overMenu || this.overMenuToogle) {
      myDrop.open();
    } else {
      myDrop.close();
    }
  }

  setOverMenu(isOver: boolean, myDrop: NgbDropdown) {
    this.overMenu = isOver;
    if (this.overMenu || this.overMenuToogle) {
      myDrop.open();
    } else {
      myDrop.close();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes?.itemMenuOpenedId?.currentValue) {
      if (this.item.id !== changes.itemMenuOpenedId.currentValue) {
        this.itemMenuOpen = false;
      }
    }
  }

  openMenu(item: NavItem) {
    if (this.autoCloseMenuItem) {
      this.clickItem.emit(item);
    }
    this.itemMenuOpen = !this.itemMenuOpen;
  }
}
